import Switchers from './Switchers';

const els = document.querySelectorAll('.js-switchers');

for (let el of els) {
    new Switchers(el);
}
